/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { isFunction } from "utils/APIUtils";
import { featureLifecycleHookController } from "./controller/featureLifecycleHookController";
import { featureLifecyleHooks } from "constants/enums";

const getStickyToolsApis = stores => {
  function beforeToolActivated(callback, opts = {}) {
    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.BEFORE_STICKY_TOOL_ACTIVATED, callback);
    }
  }

  function registerStickyToolsAddOnPanel(callback, opts = {}) {
    stores.stickyToolsStore.registerStickyToolsAddOnPanel(callback);
    return true;
  }

  return {
    beforeToolActivated,
    registerStickyToolsAddOnPanel
  };
};

export const registerStickyToolsApis = stores => {
  apiFactory.registerApi(publicApiNames.STICKYTOOLS, clientName => getStickyToolsApis(stores), true);
};
